import { config, handleResponse } from '../../_helpers';

export const portService = {
    getPorts,
    getPortById,
    createPort,
    updatePort,
    deletePorts,
    activation,
    getActivePorts,
    getIsActivePortsBranch,
    branchWithPorts
};

function getPorts(skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (filter && search) {
        return fetch(`${config.apiUrl}/ports/load?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/ports/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function getPortById(id) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/ports/get/${id}`, requestOptions).then(handleResponse);
}
function createPort(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Ports`, requestOptions).then(handleResponse);
}
function updatePort(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload, id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/ports/update/${id}`, requestOptions).then(handleResponse);
}
function deletePorts(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/ports/delete`, requestOptions).then(handleResponse);
}
function activation(id, isActive) {
    const requestOptions = {
        method: 'PUT'
    };
    return fetch(`${config.apiUrl}/ports/activate/${id}?isActive=${isActive}`, requestOptions).then(handleResponse);
}
function getActivePorts() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/ports/getIsActive`, requestOptions).then(handleResponse);
}
function getIsActivePortsBranch(branchCode) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/ports/getIsActivePortsBranch?BranchCode=${branchCode}`, requestOptions).then(handleResponse);
}
function branchWithPorts(branchCode) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/ports/BranchWithPorts?BranchCode=${branchCode}`, requestOptions).then(handleResponse);
}
